<script setup lang="ts">
// Wraps the app in NConfigProvider wired to the site's CSS tokens.
// Overrides are computed onMounted — see theme.ts for why.
import { onMounted, ref } from 'vue'
import { NConfigProvider, NMessageProvider, darkTheme, type GlobalThemeOverrides } from 'naive-ui'
import { buildNaiveTheme, siteScheme } from './theme'

const overrides = ref<GlobalThemeOverrides>({})
const scheme = ref<'dark' | 'light'>('light')

onMounted(() => {
    scheme.value = siteScheme()
    overrides.value = buildNaiveTheme()
})
</script>

<template>
    <NConfigProvider :theme="scheme === 'dark' ? darkTheme : null" :theme-overrides="overrides">
        <NMessageProvider>
            <slot />
        </NMessageProvider>
    </NConfigProvider>
</template>
